import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  navigationContainer: {
    paddingTop: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
  },
  navigationTitle: {
    fontSize: '0.875rem',
    fontWeight: 500,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  stepsList: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  stepChip: {
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
      borderColor: theme.palette.primary.main,
    },
  },
}));
